var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 160 101"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__a",
    width: 30,
    height: 20,
    x: 63,
    y: 16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.285 17.273c-.31.128-1.36.584-1.64.74-4.047 2.193-14.017 13.727-14.032 15.607v.128c.192.997 16.942 2.193 21.477.811.31-.1 1.373-.526 1.683-.655 3.545-1.495 5.672-4.841 5.672-8.344a8.8 8.8 0 0 0-.783-3.617c-1.55-3.403-5.022-5.44-8.64-5.44a9.7 9.7 0 0 0-3.752.756"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#login_svg__b)",
    d: "M92.475 16.518H63.613v19.436h28.862z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__c",
    width: 24,
    height: 35,
    x: 61,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.18 3.36a10.7 10.7 0 0 0-2.333 3.49c-.148.355-.665 1.622-.768 1.993-.458 1.552-.665 4.243-.665 7.304 0 6.707.93 15.194 1.994 17.301.118.228.222.356.34.427 2.112 1.61 16.262-12.132 19.32-16.83.398-.613.738-1.31 1.033-2.236.4-1.282.606-2.563.606-3.83 0-4.429-2.481-8.43-7.03-10.21A11.9 11.9 0 0 0 74.027 0h-.59c-3.103 0-6.086 1.225-8.243 3.375"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login_svg__d)",
    d: "M71.033-11.07 43.28 20.816l31.795 25.719 27.752-31.884z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__f",
    width: 15,
    height: 23,
    x: 63,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.24,
    cy: 10.995,
    fill: "url(#login_svg__e)",
    rx: 6.24,
    ry: 10.995,
    transform: "matrix(.96233 .2776 -.2918 .95474 67.652 3.137)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F84CB",
    d: "M75.55 5.969c-3.895 2.672-7.6 13.345-8.965 18.348l2.157 2.77 10.48-9.519z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__h",
    width: 18,
    height: 12,
    x: 72,
    y: 20,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.978,
    cy: 8.696,
    fill: "url(#login_svg__g)",
    rx: 4.978,
    ry: 8.696,
    transform: "matrix(.44974 .8568 -.92211 .45229 86.863 17.994)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#287ABF",
    d: "M89.474 23.935c-3.732-.721-12.128 3.006-15.86 4.96l-.466 2.706 11.428.676z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M13.199 66.225c3.635 0 6.585-2.62 6.585-6.23 0-2.339-1.222-4.115-3.07-5.077 1.372-.991 2.22-2.56 2.22-4.454 0-3.478-2.875-6.038-6.42-6.038H3.796v21.799zM7.402 53.512V47.77h5.11c1.594 0 2.816 1.243 2.816 2.871s-1.222 2.871-2.816 2.871zm5.796 3.256c1.698 0 2.98 1.332 2.98 3.049v.015c0 1.716-1.282 3.048-2.98 3.048H7.402v-6.112z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M30.29 54.016v-3.641c-1.967 0-3.89.784-4.828 2.9v-2.619H22.08v15.569h3.382V58.38c0-3.492 2.608-4.528 4.828-4.365"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M47.574 66.224H44.19v-2.25c-1.192 1.658-3.04 2.65-5.483 2.65-4.26 0-7.807-3.581-7.807-8.199 0-4.617 3.546-8.198 7.807-8.198 2.444 0 4.291.991 5.483 2.619v-2.205h3.383zM44.19 58.44c0-2.9-2.13-4.987-4.961-4.987s-4.962 2.086-4.962 4.987c0 2.9 2.13 4.987 4.962 4.987 2.83 0 4.961-2.086 4.961-4.987",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "m59.113 66.225 6.11-15.568h-3.696l-4.366 11.839-4.38-11.84h-3.71l6.124 15.57z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M65.226 58.44c0-4.647 3.695-8.198 8.284-8.198s8.285 3.551 8.285 8.198-3.666 8.199-8.285 8.199-8.284-3.581-8.284-8.199m13.171 0c0-2.841-2.13-4.928-4.887-4.928s-4.887 2.087-4.887 4.928c0 2.842 2.131 4.928 4.887 4.928 2.757 0 4.887-2.086 4.887-4.928",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M96.248 47.86h6.169v-3.434H86.43v3.433h6.213v18.366h3.605z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M99.348 58.44c0-4.647 3.695-8.198 8.284-8.198s8.284 3.551 8.284 8.198-3.665 8.199-8.284 8.199-8.284-3.581-8.284-8.199m13.171 0c0-2.841-2.131-4.928-4.887-4.928s-4.887 2.087-4.887 4.928c0 2.842 2.131 4.928 4.887 4.928s4.887-2.086 4.887-4.928",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M132.184 66.225V50.642h-3.382v8.346c0 3.182-1.848 4.484-3.978 4.484s-3.516-1.243-3.516-3.61v-9.22h-3.383v9.56c0 4.055 2.503 6.423 6.02 6.423 2.13 0 3.814-.77 4.857-2.398v1.998zM143.09 50.375v3.64c-2.22-.162-4.827.874-4.827 4.366v7.844h-3.382V50.656h3.382v2.62c.938-2.117 2.86-2.901 4.827-2.901M149.709 66.64c3.382 0 6.108-1.673 6.108-4.796h.015c0-3.381-2.909-4.184-5.31-4.847-1.687-.465-3.123-.862-3.123-2.034 0-1.125 1.013-1.658 2.295-1.658 1.281 0 2.384.563 2.95 1.776l2.846-1.583c-1.088-2.057-3.219-3.241-5.796-3.241-3.189 0-5.737 1.835-5.737 4.765 0 3.273 2.904 4.091 5.303 4.767 1.69.476 3.13.882 3.13 2.026 0 1.243-1.162 1.746-2.667 1.746-1.728 0-2.98-.844-3.486-2.25L143.317 63c.998 2.234 3.263 3.64 6.392 3.64"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#0E2336",
    clipPath: "url(#login_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.209 89.867h1.379V84.8h1.933v-1.323h-5.209V84.8h1.897zM47.836 90.159a1.9 1.9 0 0 0-.794-.155q-.4 0-.725.141-.326.143-.522.397-.198.255-.229.602h.844a.46.46 0 0 1 .21-.325.77.77 0 0 1 .416-.106q.225 0 .36.077a.46.46 0 0 1 .2.235q.065.158.065.397h-.805q-.465 0-.77.129a1 1 0 0 0-.458.355.9.9 0 0 0-.151.521q-.001.271.125.493a.9.9 0 0 0 .39.355q.264.132.67.132.195 0 .355-.041a1.1 1.1 0 0 0 .516-.3q.097-.104.168-.232l.096.496h.735V91.32q0-.425-.18-.716a1.16 1.16 0 0 0-.516-.445m-.214 1.804a1.2 1.2 0 0 1-.074.3.8.8 0 0 1-.151.244.7.7 0 0 1-.529.23.6.6 0 0 1-.25-.046.37.37 0 0 1-.168-.129.37.37 0 0 1-.058-.212q0-.117.058-.206a.36.36 0 0 1 .183-.14.9.9 0 0 1 .326-.047h.664zM57.723 83.62v15.412c0 .012.01.023.023.023a.957.957 0 0 0 .957-.957V82.641a.98.98 0 0 0-.98.98M79.466 82.64c-1.947 0-3.602 1.096-4.299 2.63-.69-1.54-2.365-2.63-4.323-2.63-2.576 0-4.664 1.885-4.664 4.21v.04c.023.818.249 2.46 1.429 4.596 0 0 4.419 2.481 10.2-3.484l-1.551.925s-1.53-.488-1.658-.535c-.208-.076-.247-.11-.247-.246 0-.085.042-.159.107-.203.04-.027.502-.398.502-.398s3.35.013 3.368 0c.047-.039.078-.066.108-.093l1.027-.87c.382-.382.886-.497 1.126-.256.24.24.126.744-.256 1.126l-.675.66-.383.377-.315 3.426s-.447.419-.479.455a.25.25 0 0 1-.214.086c-.135-.014-.165-.057-.219-.27a204 204 0 0 1-.359-1.705l1.26-1.677-3.737 3.623s-2.641 2.46-5.497 2.041c1.185 1.384 2.776 2.881 4.896 4.428.156.09.346.162.54.162.218 0 .412-.067.597-.19 7.542-5.502 8.35-10.399 8.38-12.016-.002-2.325-2.09-4.21-4.666-4.21zM112.641 89.914c.16 0 .404-.019.526-.047V88.6c-.263 0-.451-.085-.451-.544v-4.58h-1.361v5.067c0 .986.601 1.37 1.286 1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.215 89.867h1.37v-3.05c.3-.262.73-.318 1.116-.318h.31v-1.248c-.122-.075-.328-.085-.469-.085-.498 0-.929.31-1.248.666a1.33 1.33 0 0 0-1.08-.553zM25 93.33h2.965v-.702H25.87v-1.25h1.902V90.7H25.87v-1.179h2.095v-.703H25zM36.605 90.502a1.1 1.1 0 0 0-.426-.368 1.4 1.4 0 0 0-.612-.129 1.5 1.5 0 0 0-.803.223q-.358.222-.56.606a1.85 1.85 0 0 0-.204.88c0 .33.066.612.2.87q.201.387.552.606.351.22.797.22.27 0 .47-.072a1.1 1.1 0 0 0 .345-.193 1.4 1.4 0 0 0 .241-.258l.098.445h.773V88.69h-.87v1.81zm-.09 1.696a.8.8 0 0 1-.306.332.86.86 0 0 1-.454.12.84.84 0 0 1-.759-.452 1.05 1.05 0 0 1-.112-.497c0-.19.037-.342.112-.484a.84.84 0 0 1 .758-.451q.257 0 .454.119.196.12.306.332t.11.49-.11.49zM31.397 90.171a1.3 1.3 0 0 0-.684-.167q-.38 0-.654.167a1.17 1.17 0 0 0-.423.438l-.064-.528h-.767v3.25h.87v-1.735q0-.27.096-.461a.7.7 0 0 1 .268-.294.74.74 0 0 1 .39-.103q.342 0 .506.206t.164.593v1.792h.864v-1.876q0-.47-.145-.793a1.07 1.07 0 0 0-.422-.49zM43.288 88.691h-.87v4.642h.87zM40.832 90.217a1.6 1.6 0 0 0-.845-.213 1.7 1.7 0 0 0-.873.222 1.53 1.53 0 0 0-.584.612q-.206.39-.206.9c0 .34.07.622.21.874q.21.377.586.587.377.21.867.21.38 0 .69-.141a1.5 1.5 0 0 0 .825-.935h-.889a.65.65 0 0 1-.236.265.7.7 0 0 1-.396.103.8.8 0 0 1-.419-.107.73.73 0 0 1-.281-.303 1 1 0 0 1-.095-.37h2.393a1 1 0 0 0 .014-.165v-.146q0-.457-.2-.819a1.5 1.5 0 0 0-.562-.573zm-1.629 1.173a1 1 0 0 1 .085-.27.7.7 0 0 1 .293-.307q.187-.1.406-.1.303 0 .507.18.203.18.222.497zM50.467 89.793q0-.199.087-.28.087-.08.293-.08h.27v-.742h-.399q-.342 0-.596.11a.8.8 0 0 0-.39.349q-.135.238-.135.644v.29h-.445v.729h.445v2.52h.87v-2.52h.703v-.729h-.703v-.29M116.687 85.165a2.43 2.43 0 0 0-1.444.488l-.01.01v-.817c0-.76-.61-1.37-1.37-1.37v6.39h1.37v-2.898c.263-.254.648-.47 1.022-.47.423 0 .516.263.516.648v2.721h1.37v-2.796c0-1.003-.216-1.904-1.455-1.904zM113.697 96.64l-1.117-2.572h-1.389l1.811 4.176-.957 2.195h1.399l2.758-6.37h-1.389zM121.063 85.176c-1.435 0-2.29 1.041-2.29 2.402s.882 2.374 2.29 2.374c.723 0 1.389-.216 1.867-.77l-.844-.675c-.281.29-.535.385-.948.385-.6 0-1.041-.3-1.107-.92h3.304c.018-.13.028-.272.028-.412 0-1.38-.929-2.383-2.3-2.383zm-1.004 1.82c.113-.498.507-.76 1.014-.76.544 0 .873.253 1.004.76zM129.813 85.832a1.33 1.33 0 0 0-1.079-.553v4.588h1.37v-3.05c.3-.262.731-.318 1.116-.318h.31v-1.248c-.122-.075-.328-.085-.468-.085-.498 0-.929.31-1.249.666M134.997 86.536v-1.257h-1.024v-1.107h-1.106l-.282 1.107h-.694v1.257h.713v1.802c0 1.135.619 1.604 1.632 1.604.31 0 .544-.038.761-.103v-1.286a1.6 1.6 0 0 1-.479.075c-.328 0-.545-.168-.545-.59v-1.502zM125.959 85.166a4.15 4.15 0 0 0-1.642.356l.375.994c.329-.14.704-.215 1.07-.215.403 0 .75.188.75.628v.263c-.281-.197-.638-.29-1.079-.29-.948 0-1.679.59-1.679 1.548s.741 1.539 1.67 1.539c.478 0 .901-.113 1.248-.44l.094.318h1.117v-2.88c0-1.23-.779-1.821-1.924-1.821m-.216 3.847c-.347 0-.769-.15-.769-.563s.404-.563.769-.563c.366 0 .779.13.779.563s-.431.563-.779.563M110.646 96.846v-4.578h-1.361v5.066c0 .986.601 1.37 1.286 1.37.16 0 .403-.02.526-.047V97.39c-.263 0-.451-.085-.451-.544M96.385 93.957c-.563 0-1.126.13-1.642.356l.375.994a2.8 2.8 0 0 1 1.07-.215c.403 0 .75.188.75.628v.263c-.282-.197-.638-.29-1.079-.29-.948 0-1.68.59-1.68 1.548s.742 1.539 1.67 1.539c.479 0 .901-.113 1.249-.44l.093.318h1.117v-2.88c0-1.23-.779-1.821-1.924-1.821m-.216 3.847c-.347 0-.769-.15-.769-.563s.403-.563.77-.563c.365 0 .778.13.778.563s-.431.563-.779.563M100.122 89.867h1.116v-2.88c0-1.23-.778-1.821-1.924-1.821a4.15 4.15 0 0 0-1.642.356l.376.994a2.8 2.8 0 0 1 1.07-.215c.402 0 .75.188.75.628v.263c-.282-.197-.638-.29-1.08-.29-.947 0-1.679.59-1.679 1.548s.742 1.539 1.67 1.539c.479 0 .901-.113 1.249-.44zm-1.023-.854c-.348 0-.77-.15-.77-.563s.404-.563.77-.563.778.13.778.563-.43.563-.778.563M90.11 98.658h1.369v-2.421h2.186v-1.314h-2.186v-1.332h2.656v-1.323h-4.026zM104.71 93.957c-.619 0-1.135.263-1.605.656-.225-.497-.666-.656-1.191-.656-.629 0-1.174.263-1.633.676a1.28 1.28 0 0 0-1.069-.563h-.056v4.588h1.37v-2.9c.243-.252.573-.468.938-.468.413 0 .488.29.488.648v2.72h1.37V95.76c.253-.253.573-.469.948-.469.14 0 .253.038.338.122q.14.13.14.526v2.72h1.379v-2.795c0-.986-.205-1.905-1.416-1.905zM110.32 89.182l-.844-.676c-.281.29-.535.385-.948.385-.601 0-1.041-.3-1.107-.92h3.303c.019-.13.028-.272.028-.412 0-1.38-.929-2.383-2.298-2.383-1.37 0-2.29 1.041-2.29 2.402s.883 2.374 2.29 2.374c.723 0 1.389-.216 1.867-.77zm-1.858-2.947c.544 0 .873.254 1.004.76h-2.017c.113-.497.507-.76 1.013-.76M103.815 88.186l-.986-2.909h-1.407l1.735 4.588h1.324l1.651-4.588h-1.379zM108.385 94.068h-1.369v4.588h1.369zM107.701 91.807a.81.81 0 0 0-.806.806.807.807 0 1 0 1.613 0 .8.8 0 0 0-.807-.806"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "login_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 10.9955 -6.24028 0 6.24 10.995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "login_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 8.69634 -4.97779 0 4.978 8.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_svg__b",
    x1: 64.817,
    x2: 93.664,
    y1: 26.931,
    y2: 26.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2A97D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2577BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_svg__d",
    x1: 58.666,
    x2: 80.716,
    y1: 32.223,
    y2: 4.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#41C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "login_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 82.64h110v17.798H25z"
  })))));
};
export default SvgLogin;